module.exports = __webpack_public_path__ + "img/btn_deletar.dc8a2982.png";